<template>
  <div id="chart" class="my-3">
    <apexchart
      type="bar"
      height="450"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import axios from "axios";
const lastWeekApi =
  "https://bookinga.herokuapp.com/api/v1/adminReport/company/lastweek";
export default {
  mounted() {
    var token = localStorage.getItem("jwt");
    const headers = { Authorization: `Bearer ${token}` };
    axios.get(lastWeekApi, { headers }).then((res) => {
      const data = res.data.result;
      const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      var branchNames = [];
      if(data)
        for (let i = 0; i < data.length; i++) {
          if (branchNames.indexOf(this.capitalize(data[i].branchname)) === -1) {
            branchNames.push(this.capitalize(data[i].branchname));
          }
        }
      for (let j = 0; j < branchNames.length; j++) {
        var DaysMoney = [0, 0, 0, 0, 0, 0, 0];
        for (let i = 0; i < data.length; i++) {
          if (branchNames[j] == this.capitalize(data[i].branchname)) {
            days.forEach((day) => {
              if (day == data[i].day) {
                DaysMoney.splice(days.indexOf(day), 1, data[i].amount);
              }
            });
          }
        }
        this.series.push({
          name: branchNames[j],
          data: DaysMoney,
        });
      }
    });
  },
  methods: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          stackType: "100%",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        xaxis: {
          categories: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "right",
          offsetX: 0,
          offsetY: 50,
        },
      },
    };
  },
};
</script>

<style></style>
